import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { printHtmlToJsx } from '@utils/ast';

/**
 * Describes categories available in the shelf.
 */
class CategoryModel {
  constructor(data) {
    /** Specifies the description of the category as HTML formatted text */
    _defineProperty(this, "description", void 0);
    /** Specifies if the category should be highlighted in the user interface */
    _defineProperty(this, "highlighted", void 0);
    /** Specifies the ID of the category */
    _defineProperty(this, "id", void 0);
    /** Specifies the title of the category */
    _defineProperty(this, "title", void 0);
    Object.assign(this, data);
  }

  /** Helper that creates a model based on a serialized, json based input */
  static async DESERIALIZE(data) {
    let description = undefined;
    if (data.description) {
      description = printHtmlToJsx(data.description);
    }
    return new CategoryModel({
      ...data,
      description
    });
  }
}

export { CategoryModel };
//# sourceMappingURL=CategoryModel.js.map
